import { createRef, h } from "preact";

import Slider from "../Slider.jsx";
import { useEffect, useState } from "preact/hooks";

function selectKey(value) {
  if (Array.isArray(value)) {
    return value[1];
  }
  return value;
}
function useMinDistance(props) {
  if (props.options.range) {
    if (props.options.minDistance) {
      return (
        props.answer || [
          0,
          selectKey(props.options.possibleValues[props.options.minDistance]),
        ]
      );
    } else {
      return props.answer || [0, 0];
    }
  } else {
    return props.answer || 0;
  }
}

export default function QSlider(props) {
  const [value, setValue] = useState(useMinDistance(props));
  const ref = createRef();

  function handleChange(newValue) {
    if (value === newValue) {
      return;
    }
    setValue(newValue);
  }

  useEffect(() => {
    // Setting it initially just to make hitting ok work
    props.onSelect(value);
  }, [value]);

  let possibleValues = [];
  if (Array.isArray(props.options.possibleValues)) {
    possibleValues = props.options.possibleValues.reduce((mem, [text, key]) => {
      mem[key] = text;
      return mem;
    }, {});
  } else {
    // It is already a plain array with keys being the values and entries the texts to show.
    possibleValues = props.options.possibleValues;
  }

  return (
    <div class="mt-0" ref={ref}>
      <Slider
        id="question-slider"
        name="answer"
        class="mt-48"
        minDistance={props.options.minDistance}
        value={value}
        disabled={props.disabled}
        range={props.options.range}
        possibleValues={possibleValues}
        info={props.options.helperText}
        error={props.error}
        errorBorder={props.errorBorder}
        label={props.options.label}
        onChange={handleChange}
      />
    </div>
  );
}
